// extracted by mini-css-extract-plugin
export default {"modal__list":"kO0truwQSrPows2G6Djo","modal__choice":"n9jjohf7QzjPAN5eKhzs"};